import React from 'react';
import { Linkedin, Mail } from 'lucide-react';
import { team } from '../data/mockData';
import { Card, CardContent } from './ui/card';

const Team = () => {
  return (
    <section id="team" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-amber-400/10 border border-amber-400/20 rounded-full px-4 py-2 mb-4">
            <span className="text-amber-600 font-medium text-sm">Our Team</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            Meet Our Expert Consultants
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A diverse team of certified professionals with decades of combined experience driving impactful change
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {team.map((member) => (
            <Card
              key={member.id}
              className="group overflow-hidden hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-amber-400"
            >
              <CardContent className="p-8 text-center">
                {/* Smaller Image - Centered above name */}
                <div className="flex justify-center mb-6">
                  <div className="relative w-32 h-32 rounded-full overflow-hidden border-4 border-amber-400 group-hover:border-amber-500 transition-all duration-300 group-hover:scale-110">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover object-center"
                      style={{ objectFit: 'cover', objectPosition: 'center' }}
                    />
                  </div>
                </div>

                {/* Name and Role */}
                <div className="mb-4">
                  <h3 className="text-xl font-bold text-slate-900 mb-2">{member.name}</h3>
                  <p className="text-amber-600 font-semibold text-sm mb-3">{member.role}</p>
                  
                  {/* Specialization Badge */}
                  <div className="inline-block bg-blue-900 text-white text-xs font-semibold px-3 py-1 rounded-full mb-4">
                    {member.specialization}
                  </div>
                </div>

                {/* Description */}
                <p className="text-gray-700 text-sm leading-relaxed mb-4">
                  {member.description}
                </p>

                {/* Social Links */}
                <div className="flex items-center justify-center space-x-3 pt-4 border-t border-gray-200">
                  <button className="w-9 h-9 bg-gradient-to-br from-amber-400 to-yellow-600 rounded-full flex items-center justify-center hover:scale-110 transition-transform">
                    <Linkedin size={16} className="text-slate-900" />
                  </button>
                  <button className="w-9 h-9 bg-gradient-to-br from-amber-400 to-yellow-600 rounded-full flex items-center justify-center hover:scale-110 transition-transform">
                    <Mail size={16} className="text-slate-900" />
                  </button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Bottom Section */}
        <div className="mt-16 bg-gradient-to-r from-blue-900 to-slate-900 rounded-3xl p-8 lg:p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Join Our Team of Excellence</h3>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            We're always looking for talented consultants passionate about driving Africa's socio-economic development.
          </p>
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-gradient-to-r from-amber-400 to-yellow-600 text-slate-900 hover:from-amber-500 hover:to-yellow-700 font-semibold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105"
          >
            Get In Touch
          </button>
        </div>
      </div>
    </section>
  );
};

export default Team;
